export const GuardianshipRouteSegmentsEnum = {
  Start: 'start',
  Dashboard: 'dashboard',
  Home: 'home',
  Ward: 'ward',
  Subscribers: 'subscribers',
  FinancialAssets: 'financial-assets',
  BondSurety: 'bond-surety',
  Taxes: 'taxes',
  Forms: 'forms',
  Documents: 'documents',
  Notes: 'notes',
  Messages: 'messages',
  Invitation: 'invitation',
  Help: 'help',
} as const;

export type GuardianshipRouteSegments =
  (typeof GuardianshipRouteSegmentsEnum)[keyof typeof GuardianshipRouteSegmentsEnum];
